import api from "./api";

export const KbAPI = {
  async list() {
    const data = await api("/helpdesk/kb");
    return data.data || [];
  },

  async create(payload) {
    return api("/helpdesk/kb", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },

  async getById(id) {
    const data = await api(`/helpdesk/kb/${id}`);
    return data.data;
  },

  async update(id, payload) {
    return api(`/helpdesk/kb/${id}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },
};